import L from 'leaflet';
import { memo } from 'react';
import { Marker } from 'react-leaflet';

import { NodeType } from '../../../schema/Node.ts';
import { DetailPopup } from './DetailPopup.tsx';
import { SimplePopup } from './SimplePopup.tsx';

type NodeVariant = 'in-roadmap' | 'next-node' | 'selected-node' | 'error-node' | 'not-in-roadmap';

const iconCache = new Map<string, L.DivIcon>();

function getStopIcon(variant: NodeVariant, size: number = 12) {
  const key = `${variant}-${size}`;
  let icon = iconCache.get(key);
  if (!icon) {
    icon = L.divIcon({
      className: '',
      html: `<div class="node-marker ${variant}"
        style="width:${size}px; height:${size}px; border-width:${size / 4.5}px"></div>`,
      iconSize: [size, size],
      iconAnchor: [size / 2, size / 2],
      popupAnchor: [0, -size / 2],
    });
    iconCache.set(key, icon);
  }
  return icon;
}

interface NodeMarkerProps {
  node: NodeType;
  variant: NodeVariant;
  size: number;
  popup?: 'simple' | 'detail';
}

export const NodeMarker = memo(function NodeMarker({
  node,
  variant,
  size,
  popup = 'simple',
}: Readonly<NodeMarkerProps>) {
  return (
    <Marker icon={getStopIcon(variant, size)} position={[node.position.lat, node.position.lon]}>
      {popup === 'detail' ? <DetailPopup node={node} /> : <SimplePopup node={node} />}
    </Marker>
  );
});
